import { authHeaders } from "../../../mainApiRoutes/nonce";

export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const eventUrl = `${API_URL}/event`;

const checkinUrl = `${eventUrl}/checkin`;
const getUncheckedParticipantsLogsUrl = `${eventUrl}/unchecked`;
const eventLogsUrl = `${eventUrl}/logs`;

export const getEventLogs = async () => {
  const response = await fetch(eventLogsUrl, { headers: authHeaders() });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};

export const checkin = async (userId, eventId, key, code) => {
  const response = await fetch(checkinUrl, {
    method: "POST",
    headers: authHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify({
      user: userId,
      event: eventId,
      key: key,
      code: code,
    }),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};

export const getUncheckedParticipantsLogs = async () => {
  const response = await fetch(getUncheckedParticipantsLogsUrl, {
    headers: authHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};

/**
 * Check-in activity for the timeline.
 *
 * Every scan is recorded here, whereas event_log.checkin_at is overwritten on
 * a repeat scan - so this is the only source that places someone at the time
 * they were actually admitted.
 */
export const getCheckinActivity = async (eventId, limit = 5000) => {
  const url =
    `${API_URL}/entries/activity?limit=${limit}&source=` +
    `&event_id=${encodeURIComponent(eventId || 0)}`;
  const response = await fetch(url, { headers: authHeaders() });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};
